import React from "react"

import { makeStyles } from "makeStyles"

import { GridTemplateColumnName, GridTemplateRowName } from "./LockingSystemMatrix"

const useStyles = makeStyles<Omit<Props, "children">>()(
	(_theme, { gridColumnName, gridRowName }) => ({
		cell: {
			gridColumnStart: gridColumnName,
			gridRow: gridRowName,
		},
	}),
)

const StyledLockingSystemCell = ({ children, ...props }: Props) => {
	const { classes } = useStyles(props)

	return <div className={classes.cell}>{children}</div>
}

interface Props {
	children: React.ReactNode
	gridColumnName: GridTemplateColumnName
	gridRowName: GridTemplateRowName
}

export default StyledLockingSystemCell
